import script from "./Leads.vue?vue&type=script&setup=true&lang=js"
export * from "./Leads.vue?vue&type=script&setup=true&lang=js"

import "./Leads.vue?vue&type=style&index=0&id=f8251f88&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8251f88"]])

export default __exports__